// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAsp';

// types
import { OrderType } from 'types/order';

// reputy.jp（ACS）計測タグ
// - 着地点タグ: 全ページ共通で発火し、lptag.php と連動して計測用Cookieを発行
// - 成果地点タグ: サンクスページ（isThanks）で発火し、注文IDを args として送信
//
// Cookie発行ファイルは public/cloudwifi/lptag-reputy.php に配置され、ビルド時に
// /cloudwifi/lptag-reputy.php として出力される（LP と同階層）。着地点タグの参照先(PDIR)
// は "/cloudwifi/" を指す。※ /cloudwifi/lptag.php は別の広告タグで使用済みのため、
// ファイル名を lptag-reputy.php に変更している（ベンダー標準の lptag.php ではない）。
// なお /cloudwifi/lptag-reputy.php が index.html に書き換えられないよう、.htaccess に
// 通過ルールを追加している。
const ReputyTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();

  useEffect(() => {
    const scriptId = 'reputy';
    const cvScriptId = 'reputy-cv';
    const isExistScript = document.getElementById(scriptId);
    const isExistCvScript = document.getElementById(cvScriptId);
    if (!!isExistScript) isExistScript.remove();
    if (!!isExistCvScript) isExistCvScript.remove();

    if (isThanks) {
      // 成果地点タグ（サンクスページ）
      const orderCode = order ? (order as OrderType).order_code : '';

      const cvScript = document.createElement('script');
      cvScript.id = cvScriptId;
      cvScript.type = 'text/javascript';
      cvScript.text = `
(function acsTrack(){
var PV = "pifbiccqjgi6";
var _ARGSV = "${orderCode}";
var KEYS = {cid : ["CL_", "ACT_", "cid_auth_get_type"], plid : ["PL_", "APT_", "plid_auth_get_type"]};
var turl = "https://reputy.jp/track.php?p=" + PV + "&args=" + _ARGSV;
var cks = document.cookie.split("; ").reduce(function(ret, s){ var kv = s.split("="); if(kv[0] && kv[1]) ret[kv[0]] = kv[1]; return ret; }, []);
turl = Object.keys(KEYS).reduce(function(url, k){ var vk = KEYS[k][0] + PV; var tk = KEYS[k][1] + PV; var v = "", t = ""; if(cks[vk]){ v = cks[vk]; if(cks[tk]) t = cks[tk]; }else if(localStorage.getItem(vk)){ v = localStorage.getItem(vk); t = "ls"; } if(v) url += "&" + k + "=" + v; if(t) url += "&" + KEYS[k][2] + "=" + t; return url; }, turl);
var xhr = new XMLHttpRequest(); xhr.open("GET", turl); xhr.send(); })();
      `;
      document.body.appendChild(cvScript);
      return;
    }

    // 着地点タグ（全ページ共通）
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.text = `
window.acs_cbs = window.acs_cbs || [];
(function acsKeep(){
var PK = "p";
var IMK = "im";
var LKEYS = {cid : ["cid", "CL_", "ACT_"], gclid : ["plid", "PL_", "APT_"]};
var DKEYS = ["gclid", "gbraid", "wbraid", "msclkid", "fbclid", "yclid", "ttclid", "ldtag_cl", "ss", "msi"];
var PDIR = "/cloudwifi/";
var durl = "https://reputy.jp/direct.php";
function saveCookies(data){ var p = data[PK]; var out = Object.keys(LKEYS).reduce(function(ret, k){ if(k in data && data[k]) ret[k] = data[k]; return ret; }, {}); if(!p || !Object.keys(out).length) return;
var purl = PDIR + "lptag-reputy.php?p=" + p; Object.keys(out).forEach(function(k){ purl += "&" + LKEYS[k][0] + "=" + out[k]; localStorage.setItem(LKEYS[k][1] + p, out[k]); });
var xhr = new XMLHttpRequest(); var args = "; expires=" + new Date(new Date().getTime() + 63072000000).toUTCString() + "; path=/; SameSite=None; Secure"; xhr.open("GET", purl);
xhr.onloadend = function(){ if(xhr.status === 200 && xhr.response === ""){ window.acs_cbs.forEach(function(cb){ cb(); }); return; } Object.keys(out).forEach(function(k){ document.cookie = LKEYS[k][1] + p + "=" + decodeURIComponent(out[k]) + args; if(LKEYS[k][2]) document.cookie = LKEYS[k][2] + p + "=js" + args; }); window.acs_cbs.forEach(function(cb){ cb(); }); }; xhr.send(); }
var data = location.search.substring(1).split("&").reduce(function(ret, s){ var kv = s.split("="); if(kv[1]) ret[kv[0]] = kv[1]; return ret; }, {}); if(!(IMK in data)){ saveCookies(data); return; }
durl += "?im=" + data[IMK] + "&navi=" + performance.navigation.type; DKEYS.forEach(function(k){ if(!(k in data)) return; durl += "&" + k + "=" + data[k]; });
var xhr = new XMLHttpRequest(); xhr.open("GET", durl); function merge(a, b){ return Object.keys(LKEYS).reduce(function(ret, k){ if(k in b && !(k in a)) ret[k] = b[k]; return ret; }, a); }
xhr.onloadend = function(){ if(xhr.status !== 200) return; try{ var xhr_data = JSON.parse(xhr.responseText); if(PK != "p"){ xhr_data[PK] = xhr_data["p"]; } saveCookies(merge(xhr_data, data)); }catch(_){ } }; xhr.send(); })();
    `;
    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isThanks, order]);

  return <></>;
};

export default ReputyTag;
